import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import MoveYouOutWrapper from "@components/layouts/moveyououtWrapper";

export default function InsureYourCarHome(): ReactElement {
    return (
        <MoveYouOutWrapper>
            <TermsAndConditions category="Moving" domain="MoveYouOut.com" />
        </MoveYouOutWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
